import { useEffect, useState } from 'react';
import { usePlaytesterStore } from '../../stores/playtester-store.js';

/**
 * DiceResultToast — auto-dismissing notification for dice rolls and coin flips.
 * Reads diceResult and diceResultExpiresAt from the playtester store.
 * Auto-hides when the expiry time is reached.
 */
export default function DiceResultToast() {
  const diceResult = usePlaytesterStore((s) => s.diceResult);
  const diceResultExpiresAt = usePlaytesterStore((s) => s.diceResultExpiresAt);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!diceResult || !diceResultExpiresAt) {
      setVisible(false);
      return;
    }

    setVisible(true);

    const remaining = diceResultExpiresAt - Date.now();
    if (remaining <= 0) {
      setVisible(false);
      return;
    }

    const timer = setTimeout(() => setVisible(false), remaining);
    return () => clearTimeout(timer);
  }, [diceResult, diceResultExpiresAt]);

  if (!visible || !diceResult) return null;

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-[150] pointer-events-none animate-in fade-in slide-in-from-top-2 duration-200">
      <div className="bg-gray-900/95 border border-gray-700 rounded-xl shadow-xl px-5 py-3 text-center">
        <div className="text-xs text-gray-500 uppercase tracking-widest mb-0.5">
          {diceResult.label}
        </div>
        <div className="text-3xl font-black text-white leading-none">
          {diceResult.value}
        </div>
      </div>
    </div>
  );
}
